module.exports = __webpack_public_path__ + "img/original-sketch-3.852abc04.png";